var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-col align-items-center tw-my-24 md:tw-my-26"},[_c('img',{staticStyle:{"width":"150px","height":"150px"},attrs:{"src":_vm.NoDataImg,"alt":""}}),_c('span',{staticStyle:{"text-align":"center","color":"#999","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t("暂无记录")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }